export class AnonymizeUserVM {
  userId: string;
  password: string;
  reason: string;
}
